import React from 'react';
import { useQuery } from 'react-query';
import { useParams, useNavigate, NavLink } from 'react-router-dom';
import { Box, Image, Spinner, Text, Button, VStack, HStack, Stack, useToast, Badge, Divider } from '@chakra-ui/react';
import AuctionService from '../../services/AuctionService';
import CustomSpinner from './CustomSpinner';
import Api from '../../api/ApiUrl'

const AuctionDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();

  const { data, isLoading, error } = useQuery(['auctionDetails', id], () => AuctionService.fetchAuctionDetails(id));

  if (isLoading) {
    return <CustomSpinner />;
  }

  if (error) {
    return <Box>Error loading auction details.</Box>;
  }

  const auctions = data.data;
console.log(auctions)
  return (
    <Box maxW="5xl" mx="auto" p={4}>
   <NavLink to={`/dashboard/admin/auctions/billings/${id}`}>   <Button bg={'green'} _hover={{bg: 'green.500'}} color={'white'}>Billings</Button></NavLink>
      {auctions.map((auction) => (
        <VStack spacing={4} align="start" key={auction._id} mb={8} p={4} border="1px" borderColor="gray.200" borderRadius="md">
          <HStack spacing={4} align="center">
            {auction.coverphoto && (
              <Image
                src={`${Api}/${auction.coverphoto.path}`}
                alt={auction.coverphoto.name}
                boxSize="200px"
                borderRadius="md"
              />
            )}
            <Box>
              <Text fontSize="2xl" fontWeight="bold">{auction.name}</Text>
              <Badge colorScheme="green" variant="solid" mt={2}>{auction.status.toUpperCase()}</Badge>
              <Text mt={2}><strong>Description:</strong> {auction.description}</Text>
            </Box>
          </HStack>

          <Divider />

          <Stack spacing={4} direction={["column", "row"]} align="start" w="full">
            <VStack align="start" w="full">
              <Text><strong>Start Price:</strong> {auction?.mainlystartPrice}</Text>
              <Text><strong> Price now:</strong> {auction.startPrice}</Text>

              <Text><strong>Min Bid Increment:</strong> {auction.minBidIncrement}</Text>
              <Text><strong>Total Bids:</strong> {auction.totalBids}</Text>
              <Text><strong>Total Bid Amount:</strong> {auction.totalBidAmount}</Text>
            </VStack>
            <VStack align="start" w="full">
              <Text><strong>Total Winners:</strong> {auction.totalWinners}</Text>
              <Text><strong>Total Losers:</strong> {auction.totalLosers}</Text>
          
              <Text><strong>Winner Amount Without Tax:</strong> {auction.startPrice}</Text>

{/* <Text><strong>Total Winner Amount After Tax and Deposit  :</strong> {auction.winnerAmount}</Text> */}
            </VStack>
          </Stack>

          <Divider />

          <HStack spacing={4}>
            <Button colorScheme="blue" onClick={() => navigate(`/dashboard/admin/auctions/${auction._id}/winner`)}>View Winners</Button>
            <Button colorScheme="red" onClick={() => navigate(`/dashboard/admin/auctions/${auction._id}/loser`)}>View Losers</Button>
          </HStack>
        </VStack>
      ))}
    </Box>
  );
};

export default AuctionDetails;
